// This function returns an array
// [{productId: ... , productAmount: ...}, {productId: ... , productAmount: ...}, ...]
// which is taken from the session storage if available (cache)
// otherwise the data is taken from the database if logged in
// or from the local storage if logged out

import { getWishlist } from './muun-WL-getWishlist.js';

// FETCH WISHLIST
async function fetchWlData(isLoggedIn, customerId, shopDomain) {
  let wishlistData = [];
  if (isLoggedIn) {
    try {
      wishlistData = await getWishlist(customerId, shopDomain);
      wishlistData = wishlistData.data.map((item) => ({
        productId: item.productId,
        productAmount: item.productAmount ?? 1,
      }));
    } catch (err) {
      console.error('Failed to fetch wishlist:', err);
    }
  } else {
    try {
      const data = JSON.parse(localStorage.getItem('wishlist')) || [];
      wishlistData = Array.isArray(data) ? data : [data];
    } catch (err) {
      console.error('LocalStorage error:', err);
    }
  }
  if (Array.isArray(wishlistData)) {
  } else {
    console.warn('wishlistData is not an array:', wishlistData);
    wishlistData = [];
  }

  return wishlistData;
}
// EXPORT FUNCTION WHICH RENDERS THE WISHLIST IF IT ISNT CACHED
let wishlistPromise = null;

export async function getSharedWishlist(isLoggedIn, customerId, shopDomain) {
  const cacheKey = 'muun-wishlist-cache';
  const cached = sessionStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.warn('[Cache] Corrupt JSON in sessionStorage');
      sessionStorage.removeItem(cacheKey);
      return [];
    }
  }

  if (!wishlistPromise) {
    wishlistPromise = fetchWlData(isLoggedIn, customerId, shopDomain).then((data) => {
      sessionStorage.setItem(cacheKey, JSON.stringify(data));
      wishlistPromise = null; // reset for future use
      return data;
    });
  }
  return wishlistPromise;
}

// EXPORT FUNCTION WHICH RENDERS THE WISHLIST ANEW WHENEVER NECESSARY
export async function updateWishlist(isLoggedIn, customerId, shopDomain) {
  const cacheKey = 'muun-wishlist-cache';
  const wishlistData = await fetchWlData(isLoggedIn, customerId, shopDomain);
  sessionStorage.setItem(cacheKey, JSON.stringify(wishlistData));
  return wishlistData;
}
